import { IconsLibrary } from '@elotech/components';
import { library } from '@fortawesome/fontawesome-svg-core';
import { IconLibrary } from 'itbi-common/components';

library.add(...IconLibrary);
library.add(IconsLibrary);
